import { useEffect, useState } from 'react';
/* import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form'; */
import useErrors from 'hooks/useErrors';
import { whatsappService } from 'services';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { contextWhatsApp } from 'context';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const useWhatsApp = () => {
 const { setError } = useErrors();
 const [data, setData] = useState([]);
 const { /* sendJsonMessage, sendMessage, */ broadcast, qr } = contextWhatsApp();
 const { newBot, getBots, logout, deletBot } = whatsappService.useApiWhatsApp();

 const mutateBot = useMutation(newBot);
 const mutate = { Logout: useMutation(logout), Delet: useMutation(deletBot) };
 const queryClient = useQueryClient();
 const [isLoaded, setIsLoaded] = useState(false);

 const {
  watch,
  reset,
  trigger,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: { name: '', options: { provider: '' } } });

 const sessionOff = async (bot, fnc = 'Logout') => {
  mutate[fnc].mutate(bot, {
   onSuccess: () => queryClient.invalidateQueries(['whatsapp']),
   //onSettled: () => setIsLoaded(false),
   onError: err => setError(err)
  });
 };

 const onSubmitData = async bot => {
  setIsLoaded(true);
  console.log(bot, 'antes de enviar');
  mutateBot.mutate(bot, {
   onSuccess: obj => console.log(obj),
   onSettled: () => setIsLoaded(false),
   onError: err => setError(err)
  });
 };

 const onError = err => {
  console.log('se produjo un error ', err);
 };

 useQuery({
  queryKey: ['whatsapp'],
  queryFn: getBots,
  onSuccess: data => setData(data.map(e => ({ ...e, qr: qr[e.name] ?? null }))),
  onError: err => setError(err),
  //enabled: true,
  staleTime: Infinity
 });

 useEffect(() => {
  setData(data.map(e => ({ ...e, qr: qr[e.name] ?? null })));
 }, [qr]);

 useEffect(() => {
  if (broadcast?.ADMIN_ALERT) {
   const { msg, accion } = broadcast.ADMIN_ALERT;
   if (accion === 'connected') queryClient.invalidateQueries(['whatsapp']);
   if (accion) toast[accion === 'connected' ? 'success' : 'error'](msg);
  }
 }, [broadcast]);

 return { data, onSubmitData, sessionOff, onError, isLoaded, watch, reset, trigger, register, setValue, handleSubmit, errors };
};

export default useWhatsApp;
